
<div mat-dialog-title>Option Chains<button class="close" mat-button title="Cancel" (click)="close()">
    <i class="material-icons clear">clear</i>
</button></div>
<mat-dialog-content>
    <irb-option-chains [optionChainData]="optionChainInput" (closeOptionChainDialog)="close()"></irb-option-chains>
</mat-dialog-content>
